import loansBorrowersOptions from './loansBorrowersReducer';

const reducer = {
  loansBorrowersOptions,
};

export default reducer;
